import {Component, Input, OnInit} from '@angular/core';
import {ModelsService} from '@irb/irb-models/models-new/models.service';
import {AppService} from '@irb/app.service';
import {IrbAppEvents} from '@irb/app.events';
import {RebalanceResultService} from '@irb/irb-rebalance/results/results.service';
import {Router} from '@angular/router';

@Component({ standalone: false,
  selector: 'editor-model-prevnext',
  templateUrl: './editor-model-prevnext.component.html',
  styleUrls: ['./editor-model-prevnext.component.scss']
})
export class EditorModelPrevnextComponent implements OnInit {

  @Input() eventPrevNextObject: any;
  lastItem: boolean = false;
  rowIndex: number;

  constructor(private modelsService: ModelsService,
              private as: AppService,
              private rebalanceResultService: RebalanceResultService,
              private router: Router) { }

  ngOnInit(): void {
    this.getIndexes();
  }

  private getIndexes() {
    this.rowIndex = this.eventPrevNextObject && this.eventPrevNextObject.data && this.eventPrevNextObject.data.rowIndex;
    this.checkForLast();
  }

  private checkForLast() {
    let countDisplayed: any;
    if (this.eventPrevNextObject.rebalanceResults) {
      countDisplayed = this.rebalanceResultService.getCurrentResultCountDisplayed();
    } else {
      countDisplayed = this.modelsService.getCurrentModelsCountDisplayed();
    }

    if (countDisplayed !== null) {
      countDisplayed = Number(countDisplayed);
      this.lastItem = countDisplayed === (this.rowIndex + 1);
    }
  }

  openNextPrevItem(isNext: boolean) {

    let nextIndex = this.rowIndex;
    if (isNext) {
      nextIndex = this.rowIndex + 1;
    } else { //isNext === false (previous)
      nextIndex = this.rowIndex - 1;
    }
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

    if (this.eventPrevNextObject.type === 'IRBMODELSEVENTS.SHOW_EDIT_MODEL') {
      this.modelsService.getPrevnextModel(nextIndex).subscribe((responseData: any) => {
        const res: any = responseData.body;
        if (res !== undefined && res.length !== 0) {
          let eventData: any = res[0];
          eventData = Object.assign(eventData, this.eventPrevNextObject.data);
          eventData.rowIndex = nextIndex;
          eventData.showNextPrev = true;
          this.as.fireEvent(this.eventPrevNextObject.type, eventData);
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }
      }, () => {this.as.fireEvent(IrbAppEvents.HIDE_WAIT);});
    }

    if (this.eventPrevNextObject.rebalanceResults) {
      this.rebalanceResultService.getPrevnextModel(nextIndex).subscribe((responseData: any) => {
        const res: any = responseData.body;
        this.rebalanceResultService.setCurrentRowIndex(nextIndex);
        this.eventPrevNextObject.data.rowIndex = nextIndex;
        this.getIndexes();
        this.router.navigate(["/rebalancing/result-summary/", res[0].rebalPkgId]);
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      }, () => {this.as.fireEvent(IrbAppEvents.HIDE_WAIT);});
    }
  }
}
